import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=d67121c6&"
import script from "./Standard.vue?vue&type=script&setup=true&lang=js&"
export * from "./Standard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports